import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/form-sections"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const formSectionsApi = createApi({
    reducerPath: "formSectionsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: [],
    endpoints: (builder) => ({
        getFormSections: builder.query({
            query: ({templateId, params = {}}) => {
                const tmp = new URLSearchParams();
                tmp.append('template_id', templateId);
                for (const k in params) {
                    tmp.append(k, params[k]);
                }
                return `/?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: []
        }),
        getFormSection: builder.query({
            query: (id) => `/${id}`,
            transformResponse: (response) => response.data,
            providesTags: []
        }),
    }),
});

export const {
    useGetFormSectionsQuery,
    useGetFormSectionQuery
} = formSectionsApi;
